<template>
  <div>
    <div
      v-for="(item, index) in list"
      :key="index"
      @click="showDetail(item)"
      class="list-item"
    >
      <img
        :src="require('@assets/icon_guide.png')"
        style="width: 1.8rem;  margin-right: .5rem;"
        alt=""
      />
      <div>{{ item.title }}</div>
      <van-icon name="arrow" style="margin-right: 0;margin-left: auto;" />
    </div>
    <van-dialog v-model="show" :title="selectedItem.title">
      <img
        v-if="selectedItem.image"
        :src="selectedItem.image"
        alt=""
        style="width: 100%;height: 100%;"
      />
      <div v-else style="height: 20rem;margin: 1rem;overflow: scroll;">
        <div v-html="selectedItem.remark"></div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      list: [],
      selectedItem: ""
    };
  },
  created() {
    this.$http.post(this.$api.REFERENCE_OUTPATIENT_GUIDE).then(res => {
      this.list = res;
    });
  },
  methods: {
    showDetail(item) {
      this.show = true;
      this.selectedItem = item;
    }
  }
};
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  align-items: center;
  margin: 0.9rem;
  padding: 1rem 0;
  border-bottom: 1px solid #f4f4f4;
}
</style>

<style lang="less">
.van-dialog__message {
  overflow-x: hidden;
}
</style>
